import React, { useEffect, useRef } from "react";
import { DraggablePanelHeader } from "../../components/draggable-panel/draggable-panel-header";
import { useNutritionPanels } from "../hooks/use-nutrution-panels";
import NewPanel from "./new-panel";
import PanelReadOnly from "./panel-read-only";
import { useNutritionPanelState } from "../hooks/use-nutrition-panel-state";
import { NewPanelTabs } from "../../new-panel-tabs";
import { TemplateVersionProvider } from "../providers/template-version";

export const Panels = ({ onClosePanel, readOnly, onOpenPanelModal, isNutritionPanel, isQaEdit, togglePanel }) => {
    const { state, dispatch, panelInfo } = useNutritionPanelState();
    const { isValidationProcessing, savePanel } = useNutritionPanels();
    const popoutRef = useRef();

    // INITIAL LOAD
    useEffect(() => {
        dispatch({ type: "SAVE_PANELS", panels: panelInfo.value.panels || [], isDirty: false });
    }, []);

    return (
        <TemplateVersionProvider templateVersion={state.panels[state.selectedPanel]?.template}>
            <div ref={popoutRef}>
                {isNutritionPanel && isQaEdit && (
                    <DraggablePanelHeader
                        roleLabel="QA Coder"
                        isQaEdit={true}
                        isDirty={state.isDirty}
                        togglePanel={togglePanel}
                        isValidationProcessing={isValidationProcessing}
                        savePanel={savePanel}
                        popoutRef={popoutRef}
                        roleType="qa"
                    />
                )}
                <div className="container">
                    {!isNutritionPanel ||
                        (!isQaEdit && (
                            <div className="button-group">
                                <button
                                    disabled={isValidationProcessing}
                                    className="button"
                                    onClick={() => onClosePanel(state.isDirty)}
                                >
                                    Back
                                </button>
                                <h1 className="txt-center">Nutrition Panel</h1>
                                {!readOnly && (
                                    <button
                                        disabled={isValidationProcessing}
                                        className="button -primary"
                                        onClick={savePanel}
                                    >
                                        Save
                                    </button>
                                )}
                            </div>
                        ))}
                    <NewPanelTabs
                        onMovePanel={onOpenPanelModal}
                        selectedIndex={state.selectedPanel}
                        readOnly={readOnly}
                    />
                    {state.panels.length > 0 &&
                        (!readOnly ? (
                            <NewPanel
                                key={`panel_${state.selectedPanel}`}
                                isNutrition={isNutritionPanel}
                                panel={state.panels[state.selectedPanel]}
                                selectedIndex={state.selectedPanel}
                                isQaEdit={isQaEdit}
                            />
                        ) : (
                            <PanelReadOnly
                                key={`panel_${state.selectedPanel}`}
                                panel={state.panels[state.selectedPanel]}
                                selectedIndex={state.selectedPanel}
                            />
                        ))}
                </div>
            </div>
        </TemplateVersionProvider>
    );
};
